import axios from "axios";
import {
  STRAPI_DEV_URL,
  STRAPI_PROD_URL,
} from "../../../services/strapi-content/strapiContent.constants";

export default {
  state: {
    game: {},
    providers: [],
    selectedCategoryName: null,
    categoryId: null,
    selectedProviders: [],
    searchQuery: null,

    selectedProvidersNew: [],
    selectedSearchNew: null,
    selectedUserTypeNew: null,
    selectedCategoryNew: null,
  },
  mutations: {
    SET_GAME(state, payload) {
      state.game = payload.game;
    },
    SET_CATEGORY(state, payload) {
      (state.selectedCategoryName = payload.selectedCategoryName),
        (state.categoryId = payload.categoryId);
    },
    SET_PROVIDERS(state, payload) {
      state.selectedProviders = payload.selectedProviders;
    },
    SET_SEARCH_QUERY(state, payload) {
      state.searchQuery = payload.searchQuery;
    },

    SET_CATEGORY_NEW(state, payload) {
      state.selectedCategoryNew = payload.selectedCategoryNew;
    },
    SET_PROVIDER_NEW(state, payload) {
      state.selectedProvidersNew = payload.selectedProvidersNew;
    },
    SET_SEARCH_NEW(state, payload) {
      state.selectedSearchNew = payload.selectedSearchNew;
    },
    SET_USER_TYPE_NEW(state, payload) {
      state.selectedUserTypeNew = payload.selectedUserTypeNew;
    },
  },
  getters: {
    getGame: (state) => state.game,
    getSelectedCategoryName: (state) => state.selectedCategoryName,
    getCategoryId: (state) => state.categoryId,
    getSelectedProviders: (state) => state.selectedProviders,
    getSearchQuery: (state) => state.searchQuery,

    getCategoryNew: (state) => state.selectedCategoryNew,
    getSelectedProvidersNew: (state) => state.selectedProvidersNew,
    getSelectedSearchNew: (state) => state.selectedSearchNew,
    getUserTypeNew: (state) => state.selectedUserTypeNew,
  },
  actions: {
    // Fetch Strapi Content
    async fetchStrapiContent(context, payload) {
      const enviroment =
        process.env.VUE_APP_ENV === "development"
          ? STRAPI_DEV_URL
          : STRAPI_PROD_URL;

      try {
        const response = await axios.get(enviroment + payload.link, {
          params: payload.params || {},
        });
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
